<div [formGroup]="filterPublipostageForm">

    <div>

        <div>
            <kal-input formControlName="search" placeholder="Rechercher un champ"></kal-input>
        </div>

        <div>
            <kal-select formControlName="tag">
                <kal-option *ngFor="let tag of tagsList"
                            [value]="tag.LibelleGroupe">
                    {{ tag.LibelleGroupe }}
                </kal-option>
            </kal-select>
        </div>

    </div>

    <div *ngIf="(displayedTagsList | arrayNotEmpty) else emptyTags" class="container-list-tags">

        <div *ngFor="let tag of displayedTagsList">

            <label>
                <input (dragstart)="setDragItem($event, tag)"
                       [readOnly]="true"
                       [value]="tag.LibelleChamps"
                       onmouseover="select()"/>
            </label>

        </div>

    </div>

    <ng-template #emptyTags>
        <div class="emptyTags">
            Aucun tag
        </div>
    </ng-template>

</div>
